import { Component,  Input } from '@angular/core';
import { publicHelpers } from './../../helpers/public-helpers';
import { JoiResource } from 'globals/store/resources.data';
import { CommonModule } from '@angular/common';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { TextNoTextComponent } from 'src/app/components/misc/text-no-text.component';
import { ResourceContactCardComponent } from './resource-contact-card.component';

@Component({
    selector: 'resource-profile',
    template: `
<div class="performer-box">
  <div class="performer-pics">
    <img class="logo" *ngIf="!!resource.logoUrl" [src]="resource.logoUrl" />
    <div *ngIf="!resource.logoUrl" class="empty-logo">LOGO</div>
  </div>
  <div class="performer-info">
    <div class="bold-text">{{ resource.name }}</div>
    <div class="spacer"></div>
    <social-links *ngIf="resource?.social?.length" [socialLinks]="resource.social"></social-links>
  </div>
</div>
<hr />
<text-no-text [greyTitle]="'ABOUT RESOURCE'" [text]="resource.about" [placeholder]="'About the resource'"></text-no-text>
<hr />
<resource-contact-card 
  *ngFor="let contact of resource.contacts;"

  [readOnly]="true"
  [contact]="contact" 
  [resource]="resource"
></resource-contact-card>
  `,
    styleUrls: ['../../components/performers/performerProfile.scss', '../../components/performers/managePerformer.dialog.scss'],
    styles: [`
  resource-contact-card { margin-top: 5px; }  
`],
    standalone: true,
    imports: [CommonModule, SocialLinksComponent, TextNoTextComponent, ResourceContactCardComponent],
})
export class ResourceProfileComponent {
  publicHelpers = publicHelpers
  @Input() resource: JoiResource

}